export default {
  common: {
    learnMore: 'More',
    seeMore: 'View More',
  },
  navbar: {
    home: 'Home page',
    abortGreatWall: 'About Grandwall',
    companyIntroduction: 'Company Profile',
    developmentHistory: 'Milestones',
    honoraryQualifications: 'Honors and qualifications',
    corporateCulture: 'Company culture',
    productServices: 'Products',
    roundWireProducts: 'Round wire products',
    flatWireProducts: 'Rectangular Wire Products',
    applicationArea: 'Areas Of Application',
    partners: 'Cooperative Partners',
    greatWallPower:'Grandwall Power',
    researchStrength:'Research Strength',
    advancedEquipment:'Advanced Equipment',
    qualityAssurance:'Quality assurance',
    authoritativeCertification:'Authoritative Certificates',
    newsInformation: 'News & Events',
    companyInformation: 'Company Info',
    industryNews: 'Industry News',
    joinUs: 'Join Us',
    contactUs: 'Contact Us',
    recruitmentInformation: 'Recruitment',
  },
  footer: {
    abortUs: 'About Us',
    phone: 'Tel',
    address: 'Address',
    email: 'Email',
    facsimile: 'Fax',
    addressText: 'No.1, Great Wall Avenue, Lianshi Town, Huzhou City,Zhejiang Province ',
    website: 'Website',
    shCode: 'Stock code'
  },
  home: {
    industrialMotorField: 'Industrial motors',
    newEnergyField: 'New Energy',
    electricToolField: 'Power tools',
    automotiveElectricalField: 'Automotive electrics',
    householdAppliancesField: 'Domestic Appliances',
    instrumentationField: 'Instrumentation',
    page3Title: 'Brand Introduction',
    page4Title: 'News & Events',
    page5Title: 'Cooperative Partners'
  },
  abort: {
    titleText1: 'Sticking to science and technology innovation as the driving force',
    titleText2: 'Constant pursuit of excellence',
    titleText3: 'Dedicated to providing world-class products and services',
    corporateCultureTitle1: 'Core Values',
    corporateCultureTitle2: 'Corporate Vision',
    corporateCultureTitle3: 'Corporate Mission',
    corporateCultureTitle4: 'Business Purpose',
    corporateCultureTag1: 'Honesty,Obligations',
    corporateCultureTag2: 'Cohesion,Innovations',
    corporateCultureTag3: 'Go with the flow and ride the wave',
    corporateCultureTag4: 'Build a world brand',
    corporateCultureTag5: 'Strive to be the global No.1',
    corporateCultureTag6: 'Echnology-driven',
    corporateCultureTag7: 'Building a Green Future Together',
    corporateCultureTag8: 'Create value for customers and shareholders',
    corporateCultureTag9: 'Green,Efficient',
    corporateCultureTag10: 'Principled',
  },
  services: {
    roundTitle: 'Round wire products Spec.',
    flatTitle: 'Rectangular Wire Products Spec.',
    roundTableTitle1: 'Type',
    roundTableTitle2: 'Name',
    roundTableTitle3: 'National standard',
    roundTableTitle4: 'IEC standard',
    roundTableTitle5: 'NEMA Standard',
    explain: 'Instructions'
  },
  power: {
    researchStrength1: 'In 2014, an academic-expert research center was established in collaboration with Xi‘an Jiaotong University, Zhejiang Polytechnic University School of Mechanical Engineering and other well-known institutions. The center has undertaken more than ten national and provincial scientific research projects.',
    researchStrength2: 'Gathering a number of senior engineers, with strong scientific research strength. In 2020, the Great Wall Technology Research Institute was established, providing strong scientific and technological support for the achievement of independent advanced innovation. With more than 200 patents, participated in drafting more than 40 national and industry standards.',
    equipment1: 'MAG Enameling Line, Austria',
    equipment2: 'Auto-feeding enameled production line',
    equipment3: 'NIEHOFF Double-head large-drawing machine',
    equipment4: 'Automatic disk change 0.10-0.30mm small pulling machine',
    equipment5: 'Automatic spool change multi-head small wire enameling machine',
    equipment6: 'Automated Warehousing Systems',
    authoritativeText: 'Passed ISO9001, IATF16949, ISO14001, ISO45001 and other system certification, as well as the United States UL safety certification, in line with the EU RoHS requirements'
  },
  news: {
    tab1: 'Company Info',
    tab2: 'Industry News',
    firstPage: 'Home page',
    endPage: 'Last page',
    prevPage: 'Previous page',
    nextPage: 'Next page',
    date: 'Time',
    prevArticle: 'Previous post',
    nextArticle: 'Next post'
  },
  contact: {
    creatTime: 'Post Time',
    department: 'Departments',
    recruitmentNumber: 'Recruitment number',
    workLocation: 'Work location',
    jobNature: 'Nature of work',
    jobResponsibilities: 'Position Responsibilities',
    jobRequirements: 'Position Requirements',
    clickExpand: 'Click to expand',
    clickShrink: 'Click to close',
    applyOnline: 'Apply Online',
    name: 'Name',
    gender: 'Genders',
    birthDate: 'Date of birth',
    location: 'Domicile',
    marriage: 'Marital status',
    politicalLandscape: 'Political profile',
    qualification: 'Degree',
    professionalTitle: 'Title or qualification',
    graduationInstitution: 'Graduate School',
    major: 'Major',
    graduationDate: 'Date of graduation',
    phone: 'Telephone number',
    specialties: 'Special strength',
    email: 'Email',
    languageLevel: 'Foreign language level',
    postalCode: 'Zip code',
    address: 'Address',
    workExperience: 'Working experience',
    selfIntroduction: 'Self-introduction',
    jobApplication: 'Job application',
    male: 'Male',
    female: 'Female',
    yes: 'Yes',
    no: 'No',
    qualification1: 'Junior high and below',
    qualification2: 'High school',
    qualification3: 'Technical secondary school',
    qualification4: 'Junior college',
    qualification5: 'Undergraduate',
    qualification6: 'Master',
    qualification7: 'Doctor',
    qualification8: 'MBA/EMBA',
    rules1: 'Enter your name',
    rules2: 'Choose your gender',
    rules3: 'Enter your birth year and month',
    rules4: 'Enter your domicile',
    rules5: 'Choose your marital status',
    rules6: 'Enter your political profile',
    rules7: 'Choose your degree',
    rules8: 'Enter your title or qualification',
    rules9: 'Enter your graduation institution',
    rules10: 'Enter your major',
    rules11: 'Enter your graduation date',
    rules12: 'Enter your contact phone number',
    rules13: 'Enter your strengths ',
    rules14: 'Enter your Email',
    rules15: 'Enter foreign language qualifications',
    rules16: 'Enter zip code',
    rules17: 'Enter  your address',
    rules18: 'Enter your work experience',
    rules19: 'Enter self-introduction',
    rules20: 'Enter the position applying for',
    submit: 'Submit information'
  }
}
    


// WEBPACK FOOTER //
// ./src/lang/system/en.js